export const LOGIN = "/users/login"

export const PERMISSIONS = "/users/permissions"

export const REGISTER = "/users/register"

export const CAPTCHA_CHALLENGE = "/users/captchaChallenge"

export const CONFIRM_EMAIL = "/users/confirm-email"

export const USERS = "/users"

export const RESET_PASSWORD = "/users/resetPassword"

export const CHANGE_EMAIL = "/users/change-email"

export const CHANGE_EMAIL_CONFIRMATION = "/users/change-email-confirmation"

export const MY_USER = "/users/myAccount"

export const DELETE_USER = "/users/deletion/"

export const BILLING = "/users/billing/"

export const UPGRADE = "/users/requestUpgrade"

export const DOWNGRADE = "/users/requestDowngrade"

export const COMPANIES = "/companies"

export const UPDATELOGO = "/companies/updatelogo"

export const LOCATIONS = "/locations"

export const PART_LIST = "/partlist"

export const PUBLIC_PART_LIST = "/partlist/public-search"

export const MY_PART_LIST = "/partlist/myParts"

export const UPLOAD_LOGOS = "/uploads/logos"

export const UPLOAD_CHATATTACHMENTS = "/uploads/chat-attachments"

export const UPLOAD_QCATTACHMENTS = "/uploads/qc-attachments"

export const UPLOAD_QCCHATATTACHMENTS = "/uploads/qc-comments-attachments"

export const MY_LOCATIONS = "/locations"

export const REQUESTS = "/requests"

export const SAVEDPARTS = "/savedParts"

export const WATCH_LIST = "/watchlist"

export const RATINGS = "/ratings"

export const QC_Tests = "/qctests"

export const QC_LABORS = "/qclabors"

export const QC_REQUESTS = "/qcrequests"

export const QC_COMMENTS = "/qccomments"

export const PARTNER_COCKPITS = "/partnercockpits"

export const REPAIR_REQUESTS = "/repairrequests"
export const REPAIR_COMMENTS = "/repaircomments"
export const REPAIR_SERVICES = "/repairservices"
export const UPLOAD_REPAIRATTACHMENTS = "/uploads/repair-attachments"
export const UPLOAD_REPAIRCHATATTACHMENTS =
  "/uploads/repair-comments-attachments"

export const REPAIR_TESTS = "/repairtests"

export const OEMLOA = "/oemLoa"

export const UPLOAD_OEMLOA_ATTACHMENTS = "/uploads/oemloa-attachments"

export const DIGIKEY = "/digikey"

export const OCTOPART = "/octopart"

// CPS Programming System URLs
export const CPS_REQUESTS = "/cpsRequests"
export const CPS_COMMENTS = "/cpsRequests"
export const CPS_REQUESTS_CANCEL = "/cpsRequests"
export const UPLOAD_CPSATTACHMENTS = "/uploads/cps-attachments"
export const UPLOAD_CPSCHATATTACHMENTS = "/uploads/cps-comments-attachments"
export const CPS_SHIPMENTS = "/cpsShipments"
export const CPS_PRODUCTION_ORDERS = "/cpsProductionOrders"

// Trader Requests (Excess Stock Valuation)
export const TRADER_REQUESTS = "/traderRequests"
